module.exports = __webpack_public_path__ + "img/Wp_2092.1c627986.png";